import React from 'react';
import { Toaster as SonnerToaster } from 'sonner';

/**
 * Single app-wide toaster. Visual styling via Tailwind tokens to stay on-brand.
 * Mounted once in <App />.
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      richColors
      closeButton
      expand={false}
      toastOptions={{
        classNames: {
          toast:
            'rounded-xl border border-neutral-200 shadow-popover bg-white text-neutral-900',
          title: 'text-body font-medium',
          description: 'text-body-sm text-neutral-600',
          actionButton:
            'rounded-md bg-brand-600 px-2.5 py-1 text-caption font-medium text-white',
          cancelButton:
            'rounded-md bg-neutral-100 px-2.5 py-1 text-caption font-medium text-neutral-700',
        },
      }}
    />
  );
}

export default Toaster;
